import { buildCrudRoutes } from '@/app/arch/components/crud/CrudRouter';
import subModuleBreadcrumbs from '../../reports/subModuleBreadcrumbs';

const featureBreadcrumb = [
  ...subModuleBreadcrumbs,
  {
    text: 'Listar conciliações',
    disabled: false,
    to: 'conciliation.invoice.list',
  },
];

export default [
  ...buildCrudRoutes({
    baseName: 'conciliation.invoice',
    basePath: 'invoice-conciliation',
    baseBreadcrumbs: featureBreadcrumb,
    card: {
      title: 'Gerenciar conciliação de boleto',
      icon: 'newspaper',
    },
    moduleActive: 'contacard',
    subModuleActive: 'conciliations',
    listRoute: {
      pageContent: () => import('Modules/contacard/conciliations/invoice/invoiceConcialitonCrudList.vue'),
      filterComponent: () => import('Modules/contacard/conciliations/invoice/components/InvoiceConciliaitonFilter.vue'),
      removeButton: () => import('Modules/contacard/conciliations/invoice/components/InvoiceConciliationButton.vue'),
      searchComponent: () => import('Arch/components/crud/components/OnlySearchFilter.vue'),
      searchOptions: { label: 'Buscar conciliação', searchAttribute: 'search' },
      pageTitle: 'Listar conciliações de boleto',
      navigateBackRoute: 'contacard.submodules.list',
    },
  }),
];
